import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { UserAlertsContainer } from '@user-alerts/user-alerts.container';
import { CanActivateViaAuthGuard } from '@user-history/guard/session.guard';
import {
  SearchBarMobileCalendarContainer
} from '@shared/base-search-bar/components/calendar/components/search-bar-mobile-calendar/search-bar-mobile-calendar.container';
import { CreateAlertMobileComponent } from '@user-alerts/components/create-alert-mobile/create-alert-mobile.component';
import { calendarRoute, createAlertRoute } from '@user-alerts/constants/user-alerts-routes.constants';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        path: '',
        component: UserAlertsContainer,
        canActivate: [CanActivateViaAuthGuard]
      },
      {
        path: createAlertRoute,
        component: CreateAlertMobileComponent,
        children: [
          {
            path: calendarRoute,
            outlet: 'detail',
            component: SearchBarMobileCalendarContainer,
          }
        ]
      }
    ])
  ],
  exports: [RouterModule]
})
export class UserAlertsRoutingModule { }
